import React from "react";
import { Grid, makeStyles, FormControl, Select } from "@material-ui/core";
import ReportsCard from "./ReportsCard";
import LoadingButton from "./LoadingButton";
import { filter, pipe, pluck } from "ramda";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: 10,
  },

  cardForm: {
    paddingLeft: 20,
    paddingRight: 20,
    marginBottom: 20,
  },

  moduleSelect: {
    borderColor: theme.palette.primary.dark,
    borderWidth: 1,
    borderStyle: "solid",
  },

  buttonContainer: {
    marginBottom: 20,
    paddingLeft: 20,
    paddingRight: 20,
  },
}));

const MarcModuleSelectionCard = ({
  state,
  handleStateChange,
  modules,
  handleExportClicked,
}) => {
  const classes = useStyles();

  const handleChangeMultiple = (event) => {
    const { options } = event.target;
    const value = pipe(
      filter((opt) => opt.selected),
      pluck("value")
    )(options);

    console.log(value);
    handleStateChange("modules")(value);
  };

  return (
    <ReportsCard
      classes={{ root: classes.root }}
      cardLabel={
        "You can limit the MARC records to only selected modules. Any above selections will also" +
        " be taken into account."
      }
    >
      <Grid container spacing={2} classes={{ root: classes.cardForm }}>
        <Grid item xs={12}>
          <FormControl fullWidth classes={{ root: classes.moduleSelect }}>
            <Select
              multiple
              native
              value={state.modules}
              onChange={handleChangeMultiple}
              inputProps={{
                id: "select-modules",
              }}
            >
              {modules.map((mod) => (
                <option key={mod.id} value={mod.id}>
                  {mod.name}
                </option>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Grid
        container
        justify="flex-end"
        classes={{ root: classes.buttonContainer }}
      >
        <LoadingButton
          variant="contained"
          disableElevation
          onClick={handleExportClicked}
          disabled={state.disableExport}
          showLoading={state.showLoading}
        >
          EXPORT
        </LoadingButton>
      </Grid>
    </ReportsCard>
  );
};

export default MarcModuleSelectionCard;
